import React, { useEffect, useRef, useState } from 'react';
import SearchAlt from '../Search/SearchAlt';
import { MLPVersion } from '../Input/Input';
import Search from '../Search/Search';
import { DropdownOption, SearchProp } from './types/propTypes';

const SEARCH_TEXT_MIN_LENGTH = 3;
const DEBOUNCE_DELAY = 300;
const DEBOUNCE_DELAY_ALT = 700;

const SearchComponent = ({
  label,
  placeholder,
  labelInfo,
  dropdownOptions,
  onSearch,
  onClear,
  mlpVersion = MLPVersion.ONE,
  labelChoice = 'title',
  onSelect,
  initialSearchText = '',
  ...props
}: SearchProp & { useDebounce?: boolean }) => {
  const [searchText, setSearchText] = useState<string>('');
  const timeout = useRef<number>();

  useEffect(() => {
    setSearchText(initialSearchText);
  }, [initialSearchText]);

  const handleSearchTextChange = (text: string) => {
    setSearchText(text);
    if (text.length >  SEARCH_TEXT_MIN_LENGTH) {
      if (mlpVersion === MLPVersion.ONE) {
        debounce(DEBOUNCE_DELAY, () => onSearch(text));
      }
      if (mlpVersion === MLPVersion.TWO) {
          debounce(DEBOUNCE_DELAY_ALT, () => onSearch(text));
      }
    }
  };

  const debounce = (delay: number, callback: Function) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = window.setTimeout(() => {
      callback();
    }, delay);
  };

  return mlpVersion === MLPVersion.ONE ? (
    <Search
      className="searchBox"
      value={searchText}
      label={label}
      labelInfo={labelInfo}
      placeholder={placeholder}
      onSearch={() => null}
      onChange={(e) => handleSearchTextChange(e?.target?.value)}
      onClear={() => {
        setSearchText('');
        onClear?.();
      }}
      // onKeyDown={handleKeyPress}
      data={dropdownOptions}
      configData={{
        label: labelChoice,
        onSelect: (e) => {
          const selectedOption = e as DropdownOption;
          setSearchText(labelChoice === 'id' ? String(selectedOption.id) : selectedOption.title);
          onSelect(selectedOption);
        },
      }}
      {...props}
    />
  ) : (
    <SearchAlt
      className="searchBox"
      value={searchText}
      label={label}
      labelInfo={labelInfo}
      placeholder={placeholder}
      onSearch={() => null}
      onChange={(e) => handleSearchTextChange(e?.target?.value)}
      onClear={() => {
        setSearchText('');
        onClear?.();
      }}
      // onKeyDown={handleKeyPress}
      data={dropdownOptions}
      configData={{
        label: labelChoice,
        onSelect: (e) => {
          const selectedOption = e as DropdownOption;
          setSearchText(labelChoice === 'id' ? String(selectedOption.id) : selectedOption.title);
          onSelect(selectedOption);
        },
      }}
      {...props}
    />
  );
};

export default SearchComponent;
